export default "__VITE_ASSET__e0cd4102__"